import { Link } from "react-router-dom";
import { useCmsDoc } from "../hooks/useCmsDoc";
import { defaultLegalDoc } from "../data/legalDefaults";

export default function PrivacyPolicyPage() {
  const { data } = useCmsDoc("site", "legal", defaultLegalDoc());
  const legal = { ...defaultLegalDoc(), ...data };
  const sections = legal.privacySections?.length
    ? legal.privacySections
    : defaultLegalDoc().privacySections;

  return (
    <div className="pt-28 pb-20 bg-surface min-h-screen">
      <article className="container mx-auto px-6 max-w-3xl">
        <p className="text-[10px] font-bold uppercase tracking-widest text-brand-primary mb-3">
          {legal.privacyTitle}
        </p>
        <h1 className="font-display text-4xl font-black text-brand-dark tracking-tight mb-2">
          {legal.privacySubtitle}
        </h1>
        <p className="text-sm text-brand-dark/50 mb-10">
          Última actualización: {legal.privacyUpdated}
        </p>

        <div className="space-y-8 text-sm text-brand-dark/85 leading-relaxed">
          {sections.map((sec) => (
            <section key={sec.id || sec.title}>
              <h2 className="font-display text-xl font-bold text-brand-dark mb-2">{sec.title}</h2>
              <p className="whitespace-pre-line">{sec.body}</p>
            </section>
          ))}

          <p>
            Política de cookies:{" "}
            <Link to="/cookies" className="text-brand-primary font-semibold underline">
              /cookies
            </Link>
            . Contacto:{" "}
            <a
              href={`mailto:${legal.privacyContact}`}
              className="text-brand-primary font-semibold underline"
            >
              {legal.privacyContact}
            </a>
            .
          </p>

          {legal.legalDisclaimer ? (
            <p className="text-xs text-brand-dark/45 mt-6">{legal.legalDisclaimer}</p>
          ) : null}
        </div>
      </article>
    </div>
  );
}
